import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=2f5c22c0&scoped=true"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"
import style0 from "./Markdown.vue?vue&type=style&index=0&id=2f5c22c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c22c0",
  null
  
)

export default component.exports